export default function Header() {
    return (
      <header className="bg-[#363636] py-4 shadow-md">
        <h1 className="text-3xl font-semibold text-white text-center !important">We Are Warriors Calculator</h1>
        <h6 className="font-semibold text-white text-center">Up to Date to Version: 1.55.0</h6>
        <h6 className="font-semibold text-white text-center"><a href="https://www.reddit.com/r/wearewarriors/">Check Out the Reddit</a></h6>
      </header>
    );
  }